import { apiClient } from '../client';
import { API_ENDPOINTS, CACHE_CONFIG } from '../config';

interface SearchParams {
  q?: string;
  specialty?: string;
  location?: string;
  insuranceId?: string;
  radius?: number;
  page?: number;
  limit?: number;
}

interface NearbyParams {
  lat: number;
  lng: number;
  radius?: number;
  specialty?: string;
  insuranceId?: string;
  limit?: number;
}

interface ContactData {
  name: string;
  email: string;
  phone: string;
  message: string;
  preferredTime?: string;
}

interface RatingData {
  rating: number;
  comment?: string;
  visitDate?: string;
  categories?: {
    waitTime?: number;
    bedside?: number;
    communication?: number;
    facility?: number;
  };
}

interface ScheduleData {
  providerId: string;
  date: string;
  time: string;
  reason: string;
  insuranceId?: string;
  notes?: string;
}

class ProviderService {
  async searchProviders(params: SearchParams) {
    const queryParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined) {
        queryParams.append(key, value.toString());
      }
    });

    return apiClient.get(`${API_ENDPOINTS.providers.search}?${queryParams}`, {
      cacheTTL: CACHE_CONFIG.defaultTTL
    });
  }

  async getNearbyProviders(params: NearbyParams) {
    const queryParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined) {
        queryParams.append(key, value.toString());
      }
    });

    return apiClient.get(`${API_ENDPOINTS.providers.nearby}?${queryParams}`, {
      cacheTTL: CACHE_CONFIG.defaultTTL
    });
  }

  async getProviderDetail(providerId: string) {
    return apiClient.get(API_ENDPOINTS.providers.detail(providerId), {
      cacheTTL: CACHE_CONFIG.staticDataTTL
    });
  }

  async contactProvider(providerId: string, data: ContactData) {
    return apiClient.post(API_ENDPOINTS.providers.contact(providerId), data);
  }

  async rateProvider(providerId: string, data: RatingData) {
    const response = await apiClient.post(API_ENDPOINTS.providers.rate(providerId), data);
    // Clear provider detail cache
    apiClient.clearCache(API_ENDPOINTS.providers.detail(providerId));
    return response;
  }

  async scheduleAppointment(providerId: string, data: ScheduleData) {
    return apiClient.post(API_ENDPOINTS.providers.schedule(providerId), data);
  }
}

export const providerService = new ProviderService();